import { useContext } from 'react';
import { SuperAuthContext } from '../context/SuperAuthContext';

const useSuperAuth = () => {
  const ctx = useContext(SuperAuthContext);
  if (!ctx) throw new Error('useSuperAuth must be used inside <SuperAuthProvider>');
  return ctx;
};

export default useSuperAuth;
